import { useLocalStorage } from '@vueuse/core'
import type { Destination } from '~~/types/geo/Destination'
import { removeCookieFileds } from '~/utils/hoteles'
import { objIsEmpty } from '~/utils/format'

const STORAGE_KEY = 'byhours-search-location-history-v1'
const MAX_ITEMS = 5

function iconForDestinationType(type?: string) {
  if (type === 'hotel') return 'i-lucide-building-2'
  if (type === 'destination') return 'i-heroicons-map-pin-solid'
  if (type === 'place') return 'i-lucide-locate-fixed'
  return 'i-lucide-map-pin'
}

function historyDedupeKey(d: Destination): string {
  const cat = d.category_id ?? ''
  const el = d.element_id ?? ''
  const loc = (d.location ?? '').trim()
  if (cat === 3 && loc) return `3:${loc}`
  return `${cat}:${el}:${loc}`
}

function normalizeStoredDestination(dest: Destination): Destination {
  const plain = JSON.parse(JSON.stringify(dest)) as Destination
  const cleaned = removeCookieFileds(plain)
  if (!cleaned.icon) cleaned.icon = iconForDestinationType(cleaned.type)
  if (!cleaned.label) cleaned.label = cleaned.name_translated
  return cleaned
}

/**
 * Historial local (máx. 5) de ubicaciones buscadas; solo destino, sin fechas.
 */
export function useSearchLocationHistory() {
  const list = useLocalStorage<Destination[]>(STORAGE_KEY, [])

  function pushLocation(raw: Destination | null | undefined) {
    if (!raw || objIsEmpty(raw as object)) return
    if ((raw as Destination).locationPickKind === 'current_gps') return
    const normalized = normalizeStoredDestination(raw)
    if (!normalized.name_translated?.trim()) return

    const key = historyDedupeKey(normalized)
    const rest = list.value.filter((x) => historyDedupeKey(x) !== key)
    list.value = [normalized, ...rest].slice(0, MAX_ITEMS)
  }

  const locations = computed(() => list.value.slice(0, MAX_ITEMS))

  return { locations, pushLocation }
}
